import { RootState } from '../root.reducers';
import { TargetDeliveryTemplateAccessFunction } from './targetDeliveryTemplateAccessFunction.types';

export const getTargetDeliveryTemplateAccessFunctionList = (state: RootState): TargetDeliveryTemplateAccessFunction[] =>
  state.targetDeliveryTemplateAccessFunction.entities;

export const getTargetDeliveryTemplateAccessFunction = (
  state: RootState,
): TargetDeliveryTemplateAccessFunction | null =>
  state.targetDeliveryTemplateAccessFunction.single;

export const getSelectedTargetDeliveryTemplateAccessFunction = (
  state: RootState,
): TargetDeliveryTemplateAccessFunction[] =>
  state.targetDeliveryTemplateAccessFunction.selected;

export const getTargetDeliveryTemplateAccessFunctionCreatedId = (state: RootState): string | null =>
  state.targetDeliveryTemplateAccessFunction.createdId;

export const isTargetDeliveryTemplateAccessFunctionCreatePopupOpen = (state: RootState): boolean =>
  state.targetDeliveryTemplateAccessFunction.ui.isCreatePopupOpen;

export const isTargetDeliveryTemplateAccessFunctionLoading = (state: RootState): boolean =>
  state.targetDeliveryTemplateAccessFunction.ui.isLoading;

export const getTargetDeliveryTemplatesMap =
  (state: RootState): Partial<{ [key: string]: TargetDeliveryTemplateAccessFunction }> =>
    state.targetDeliveryTemplateAccessFunction.targetDeliveryTemplatesMap;
